<template>
    <div class="metro" v-if="loaded">
        <v-container fluid>
            <v-row align="center" class="metro-section-header">
                <v-col cols="12" class="text-center">
                    <v-img src="../assets/img/logo-metro-blanco.png" max-width="300px" class="mx-auto"></v-img>
                    <h2 class="white--text my-6">{{metroSingleton.tituloBloque1}}</h2>
                    <p class="white--text mx-auto d-block" style="max-width: 500px; font-size: 16px;">{{metroSingleton.subtituloBloque1}}</p>
                </v-col>
            </v-row>
            <v-row align="center" style="background-color: #077BE6" class="mb-0">
                <v-col cols="12" md="6" class="py-0 px-0" order="0" order-md="0">

                    <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.imagenBloque1.path" width="100%" height="50vh"></v-img>
                    
                </v-col>
                <v-col cols="12" md="6" class="py-12 py-md-0 white--text" order="1" order-md="1">
                    <v-row justify="center">
                        <v-col cols="10">
                            <div v-html="metroSingleton.descripcionBloque1"></div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="pb-0 pt-0">
            <v-row align="center" style="background-color: #077BE6">
                <v-col cols="12" md="6" class="text-center white--text py-12 py-md-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoBloque3.path" max-width="55px" class="mx-auto"></v-img>
                    <h2 class="my-12">{{metroSingleton.tituloBloque3}}</h2>
                    <h3>{{metroSingleton.descripcionBloque3}}</h3>

                    <div class="d-flex align-center justify-center mt-6">
                        <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoCaracteristica1Bloque3.path" max-width="55px"></v-img>
                        <div v-html="metroSingleton.descripcionCaracteristica1Bloque3" class="mt-3 ml-6"></div>
                    </div>

                    <div class="d-flex align-center justify-center mt-6">
                        <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoCaracteristica2Bloque3.path" max-width="55px"></v-img>
                        <div v-html="metroSingleton.descripcionCaracteristica2Bloque3" class="mt-3 ml-6"></div>
                    </div>

                </v-col>
                <v-col cols="12" md="6" class="py-0 px-0">
                    <!-- <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.mapaBloque3.path" class="mx-auto" height="500"></v-img> -->
                    <MapaServicio :mapSelected="{puntos: mapSelected.puntos, icono: mapSelected.icono, mapaPuntos: mapSelected.mapaPuntos}" />
                </v-col>
            </v-row>
            <div>
                <v-row align="center" class="metro-service-container">
                    <v-col cols="12s" md="6" class="white--text">
                        <v-row  class="internet-block-in-metro" align="center" justify="center">
                            <v-col cols="10">
                                <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoBloque4.path" max-width="65px" class="mx-auto"></v-img>
                                <h2 class="mx-auto text-center my-12">{{metroSingleton.tituloBloque4}}</h2>
                                <div v-html="metroSingleton.descripcionBloque4">
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col style="background-color: #2194FF" class="py-0">
                        <v-row class="internet-block-in-metro" align="center" justify="center" no-gutters>
                            <v-col cols="10" class="white--text">
                                <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoSubtituloBloque4.path" max-width="65px" class="mx-auto"></v-img>
                                <h2 class="mx-auto text-center my-12">{{metroSingleton.subtituloBloque4}}</h2>
                                <div v-html="metroSingleton.subdescripcionBloque4">

                                </div>
                                
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row align="center" class="metro-service-container">
                    <v-col cols="12" md="6" class="white--text">
                        <v-row class="internet-block-in-metro" align="center" justify="center">
                            <v-col cols="10">
                                <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoBloque5.path" max-width="55px" class="mx-auto"></v-img>
                                <h2 class="mx-auto text-center my-12">{{metroSingleton.tituloBloque5}}</h2>
                                <div v-html="metroSingleton.descripcionBloque5">
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6" style="background-color: #2194FF" class="py-0">
                        <v-row style="height: 500px" align="center" justify="center" class="my-0">
                            <v-col cols="10" class="white--text">
                                <div v-html="metroSingleton.subdescripcionBloque5">

                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </v-container>

        <v-container>
            <v-row>
                <v-col cols="12" class="text-center">
                    <v-img :src="'https://nncms.actstudio.xyz'+metroSingleton.iconoBloque2.path" max-width="80px" class="mx-auto"></v-img>

                    <h3 class="my-12 mt-6" style="font-size: 30px;">{{metroSingleton.tituloBloque2}}</h3>

                    <p class="break-lines">{{metroSingleton.descripcionBloque2}}</p>
                </v-col>
            </v-row>
        </v-container>

        <div class="mb-12">
            <v-container class="">
                <v-row>
                    <v-col cols="12" md="6" class="text-center pb-0">
                        <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoBloque2Caracteristica1.path" max-width="80px" class="mx-auto"></v-img>

                        <b class="mb-6 d-block">{{metroSingleton.tituloBloque2Caracteristica1}}</b>
                        <p class="mx-auto" style="max-width: 320px;">{{metroSingleton.descripcionBloque2Caracteristica1}}</p>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center pb-0">

                        <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.iconoBloque2Caracteristica2.path" max-width="80px" class="mx-auto"></v-img>

                        <b class="mb-6 d-block">{{metroSingleton.tituloBloque2Caracteristica2}}</b>
                        <p class="mx-auto" style="max-width: 320px;">{{metroSingleton.descripcionBloque2Caracteristica2}}</p>

                    </v-col>
                </v-row>
            </v-container>
        </div>

        <v-container fluid>
            <div>
                <v-row>
                    <v-col cols="12" class="pa-0">
                        <v-img :src="'https://nncms.actstudio.xyz/'+metroSingleton.imagenBloque6.path" class="white--text align-center text-center">
                            <div class="mx-auto pa-12" style="max-width: 537px" v-html="metroSingleton.textoBloque6">
                                
                            </div>
                        </v-img>
                    </v-col>
                </v-row>
            </div>
        </v-container>

        
    </div>
</template>

<script>
import MapaServicio from '../components/MapaServicio.vue'

export default {
    components: {
        'MapaServicio': MapaServicio,
    },
    data() {
        return {
            metroSingleton: {
                imagenBloque1:{
                    path: ''
                }
            },
            loaded: false,
            mapSelected: {},
        }
    },
    beforeMount: function () {

        fetch('https://nncms.actstudio.xyz/api/collections/get/Mapas?token=8cf7ca41761951fdde0c1e2cfda401', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                filter: {},
                fields: {},
                limit: 1,
                skip: 0,
                sort: {},
                populate: 1, // resolve linked collection items
                lang: 'de'
            })
        })
        .then(res=>res.json())
        .then((res)=>{
            this.mapSelected = res.entries[0];
        });
        if (this.locale == "en") {
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Metro',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lang: "en", // return normalized language fields (fieldA_de => fieldA)
                }),
            })
            .then(data => data.json())
            .then(data => this.metroSingleton = data)
            .then(() => this.loaded = true);
        }else{
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Metro')
            .then(data => data.json())
            .then(data => this.metroSingleton = data)
            .then(() => this.loaded = true);
        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale;
        },
    },
    watch: {
        locale: function () {
            if (this.locale == "en") {
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Metro',{
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        lang: "en", // return normalized language fields (fieldA_de => fieldA)
                    }),
                })
                .then(data => data.json())
                .then(data => this.metroSingleton = data)
                .then(() => this.loaded = true);
            }else{
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Metro')
                .then(data => data.json())
                .then(data => this.metroSingleton = data)
                .then(() => this.loaded = true);
            }
        }
    }
}
</script>